export const setAuthUserAction = data => {
  return {
      type: 'SET_AUTH_USER_DATA',
      payload: data,
  };
};
